var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03087 0.757359L5.48528 3.30294L2.9397 0.757359C2.47584 0.293497 1.7065 0.293497 1.24264 0.757359C0.778778 1.22122 0.778779 1.99055 1.24264 2.45442L3.78823 5L1.24264 7.54558C0.778779 8.00945 0.778778 8.77878 1.24264 9.24264C1.7065 9.7065 2.47584 9.7065 2.9397 9.24264L5.48528 6.69706L8.03087 9.24264C8.49473 9.7065 9.26406 9.7065 9.72792 9.24264C10.1918 8.77878 10.1918 8.00945 9.72792 7.54558L7.18234 5L9.72792 2.45442C10.1918 1.99055 10.1918 1.22122 9.72792 0.757359C9.26406 0.293497 8.49473 0.293497 8.03087 0.757359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.d0dd0c9def7b5102b3b9ef6cba4e50ca.svg";
export { ForwardRef as ReactComponent };